import { FunctionComponent } from "react";
import { useSelector } from "react-redux";
import RaceDetailsCard from "@ppb/tbd-components-rich-data/components/RaceDetailsCard/view/RaceDetailsCard.web";
import { ApplicationState } from "@ppb/tbd-store/state/ApplicationState.types";
import { EntityType } from "@ppb/tbd-urn-codecs";
import { useViewItemIsHighlighted } from "../../hooks/useViewItemIsHighlighted";

type Props = {
  urn: string;
  visible?: boolean;
};

/**
 * Host wrapper for the migrated `RaceDetailsCard`.
 *
 * The Card registry passes migrated cards only `{ urn, visible }`, but this card needs two values
 * that live in host state: whether the current view is My Bets (which suppresses the sticky header)
 * and whether its placement is themed `HIGHLIGHTED`. The wrapper derives both and does nothing else.
 */
const RaceDetailsCardWrapper: FunctionComponent<Props> = ({ urn, visible }) => {
  const isMyBetsView = useSelector((state: ApplicationState) => state.router.currentView === EntityType.MyBetsView);
  const isHighlighted = useViewItemIsHighlighted(urn);

  return <RaceDetailsCard urn={urn} visible={visible} stickyOnScroll={!isMyBetsView} isHighlighted={isHighlighted} />;
};

export default RaceDetailsCardWrapper;
